module.exports = __webpack_public_path__ + "img/product17p.5a1abf4d.png";